module.exports = __webpack_public_path__ + "static/img/02.1cf1d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daolan/02.jpg
// module id = 0hMy
// module chunks = 1